// The in-header pin toggle, sitting beside the column's filter trigger. Pinning moves
// the column to the front of the grid and freezes it during horizontal scroll (up to
// the frozen-width cap enforced by the grid — see useFrozenOffsets).
//
// Deliberately a plain button, not a popover: pinning is a one-click toggle, so it
// needs none of HeaderFilter's portal/positioning machinery.
export default function PinButton({ pinned, onToggle }: {
  pinned: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      className={`th-pin ${pinned ? "th-pin-active" : ""}`}
      title={pinned ? "Unpin column" : "Pin column (keeps it visible while scrolling)"}
      aria-label={pinned ? "Unpin column" : "Pin column"}
      aria-pressed={pinned}
      onClick={(e) => { e.stopPropagation(); onToggle(); }}
    >
      📌
    </button>
  );
}
